import React, { useEffect, useState } from 'react';
import ResponsiveContainer from '../../../../components/ResponsiveContainer';
import { errorHandler } from '../../../../utils';
import { cardEmpty, cards } from '../../CarUtil';
import AmpliacionTarjeta from './AmpliacionTarjeta';

const styles = {
  cardGridTitle: {
    paddingTop: 16
  },
  cardGrid: {
    paddingTop: 64,
    paddingBottom: 64
  }
};

export default function AmpliacionesFotos({
  ampliacion,
  inspeccion,
  ampliaciones,
  next
}) {
  const [stepPages, setStepPages] = useState([]);
  const [step, setStep] = useState(0);

  useEffect(() => {
    try {
      cargarDatos();
    } catch (error) {
      errorHandler(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ampliaciones]);

  const nextLocal = async (count) => {
    if (count === ampliaciones.length) {
      next();
    }
    setStep(count);
  };

  const cargarDatos = async () => {
    if (ampliaciones) {
      let stepPagesNews = [];
      stepPagesNews = await getSteps();
      setStepPages(stepPagesNews);
    }
  };

  const getSteps = async () => {
    const stepPagesNews = [];
    let count = 1;
    for (const ampliacionVar of ampliaciones) {
      // eslint-disable-next-line no-await-in-loop
      const tarjeta = await getTarjeta(ampliacionVar, count);
      count += 1;
      stepPagesNews.push(tarjeta);
    }
    return stepPagesNews;
  };

  const getTarjeta = async (item, count) => {
    const card = await searchData(item);
    if (card && Object.keys(card).length === 0 && card.constructor === Object) {
      card.item = item.key;
      // eslint-disable-next-line radix
      card.key = parseInt(item.key);
      card.parte = item.parte;
      card.image = cardEmpty.image;
    }
    return (
      <AmpliacionTarjeta
        imagen={null}
        count={count}
        next={nextLocal}
        card={card}
        inspeccion={inspeccion}
        ampliacion={ampliacion}
        countPasos={ampliaciones.length}
      />
    );
  };

  function searchData(item) {
    return new Promise((resolve) => {
      let card = {};
      cards.forEach((element) => {
        if (element.key === item.key) {
          card = element;
        }
      });
      resolve(card);
    });
  }

  return <AmpliaccionFotosRender stepPages={stepPages} step={step} />;
}

const AmpliaccionFotosRender = (props) => {
  const getRender = () => {
    return (
      <ResponsiveContainer style={styles.cardGrid}>
        {props.stepPages[props.step]}
      </ResponsiveContainer>
    );
  };

  return getRender();
};
